function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Camada_2",
  "data-name": "Camada 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Camada_1-2",
  "data-name": "Camada 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M951.17,0C564,0,79.35,480.14,58.92,500.57L0,559.49l58.92,58.92c20.43,20.42,505,500.65,892.25,500.65S1823,638.83,1843.42,618.41l58.92-58.92-58.92-58.92C1823,480.14,1338.38,0,951.17,0Zm154.75,559.49c0,236.16-93.14,392.9-154.75,392.9S796.39,795.65,796.39,559.49s93.18-392.82,154.78-392.82S1105.92,323.32,1105.92,559.49ZM682.09,245.32c-33.29,88.46-52.37,195.88-52.37,314.17s19.08,225.75,52.37,314.23C513.35,789.08,343.75,654,239.14,559.49,343.75,465,513.35,329.92,682.09,245.32ZM1220.17,873.9c33.31-88.5,52.41-196,52.41-314.41s-19.08-225.73-52.37-314.19c168.79,84.64,338.42,219.73,443,314.27C1558.68,654.13,1389,789.29,1220.17,873.9Z"
})));

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1902.34 1119.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.e539c938.svg";
export { ForwardRef as ReactComponent };